/* src/app/components/api-credentials/api-credentials.component.scss */
.apiFormButton {
  width: 100px;
  margin-top: 5px;
  margin-right: 10px;
}
input[type=password]::-ms-reveal,
input[type=password]::-ms-clear {
  display: none;
}
.haLink {
  padding: 15px 0;
}
#confirmDialog_dialog-content,
#modalDialog_dialog-content {
  padding: 0;
}
textarea {
  resize: none;
  height: 150px;
  overflow-y: scroll;
}
.hr {
  border-top: 1px solid #ccc;
}
#pass-status,
#pass-status-compare {
  margin-top: 35px;
}
input.e-input,
.e-input-group input,
.e-input-group.e-control-wrapper input,
.e-input-group input.e-input,
.e-input-group.e-control-wrapper input.e-input {
  height: 34px !important;
}
input.required,
.required {
  padding: 7px 0 11px;
}
.larger-link-font {
  font-size: 1.35em !important;
}
.language-ul {
  padding-left: 0;
}
.language-ul li {
  list-style: none;
  line-height: 1.7em;
  text-align: left;
}
.switch {
  margin: 10px 10px -5px 0;
}
.switch-div {
  margin-bottom: 20px;
}
.switch-label {
  font-size: 16px;
  color: #0071bb;
}
.e-list-item {
  border-bottom: none !important;
}
.e-rowcell.e-templatecell.e-ellipsistooltip,
.e-rowcell.e-ellipsistooltip {
  vertical-align: top;
}
.e-dialog .e-footer-content {
  text-align: center !important;
}
.e-footer-content {
  width: 100% !important;
}
.card-primary {
  border: none !important;
}
.e-grid [class^=e-] {
  box-sizing: border-box;
  border-top: none;
  border-top-width: initial;
  border-top-style: none;
  border-top-color: initial;
}
/*# sourceMappingURL=api-credentials.component.css.map */
